import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createTemplate, getTemplates } from '../../../api';
import { toast } from 'react-toastify';
import { createContainer } from 'unstated-next';
import t from '../../../lib/translate';
var initialEmailContentState = { body: '', subject: '' };
var initialSMSContentState = { body: '' };
var useTemplates = function () {
    var _a = useState(localStorage.getItem('translateTemplateKeys') ? localStorage.getItem('translateTemplateKeys') === 'true' : true), translateTemplateKeys = _a[0], setTranslateTemplateKeys = _a[1];
    var _b = useState(), templates = _b[0], setTemplates = _b[1];
    var _c = useState(), previousTemplateVersions = _c[0], setPreviousTemplateVersions = _c[1];
    var _d = useState(false), isEmailTemplate = _d[0], setIsEmailTemplate = _d[1];
    var _e = useState(initialEmailContentState), content = _e[0], setContent = _e[1];
    var _f = useState(''), templateKey = _f[0], setTemplateKey = _f[1];
    var _g = useState(isEmailTemplate ? 'EMAIL' : 'SMS'), channel = _g[0], setChannel = _g[1];
    var _h = useState(undefined), ownerpartyKey = _h[0], setOwnerpartyKey = _h[1];
    var _j = useState('STRING'), format = _j[0], setFormat = _j[1];
    var navigate = useNavigate();
    useEffect(function () {
        if (!templates) {
            getTemplates().then(function (response) { return setTemplates(response); });
        }
    }, [templates]);
    var getPreviousTemplateVersions = function () { return getTemplates(false).then(function (response) { return setPreviousTemplateVersions(response); }); };
    useEffect(function () {
        if (isEmailTemplate) {
            setContent(initialEmailContentState);
            setChannel('EMAIL');
        }
        else {
            setContent(initialSMSContentState);
            setChannel('SMS');
        }
    }, [isEmailTemplate]);
    var toggleTemplatTranslations = function () {
        localStorage.setItem('translateTemplateKeys', String(!translateTemplateKeys));
        setTranslateTemplateKeys(!translateTemplateKeys);
    };
    var createNewTemplate = function () {
        if (ownerpartyKey) {
            var template = {
                key: templateKey,
                content: content,
                ownerpartyKey: ownerpartyKey,
                format: format,
                channel: channel
            };
            createTemplate(template)
                .then(function (res) {
                toast.success(t('templates.created', res.key));
                navigate("/admin/templates/".concat(res.ownerparty.key, "/").concat(res.key, "/").concat(res.version.replace('.', '_')));
            })
                .catch(function () { return toast.error(t('templates.failed.to.save')); });
        }
    };
    return {
        content: content,
        setContent: setContent,
        templateKey: templateKey,
        channel: channel,
        ownerpartyKey: ownerpartyKey,
        setOwnerpartyKey: setOwnerpartyKey,
        format: format,
        setFormat: setFormat,
        setTemplateKey: setTemplateKey,
        createNewTemplate: createNewTemplate,
        setIsEmailTemplate: setIsEmailTemplate,
        templates: templates,
        getPreviousTemplateVersions: getPreviousTemplateVersions,
        previousTemplateVersions: previousTemplateVersions,
        translateTemplateKeys: translateTemplateKeys,
        toggleTemplatTranslations: toggleTemplatTranslations
    };
};
var Templates = createContainer(useTemplates);
export default Templates;
